import type { OfferPageDispatchAction, OfferPageState } from 'contexts/OfferPage/offerPageStateReducer'
import offerPageStateReducer, { INITIAL_OFFER_PAGE_STATE, OfferPageActions } from 'contexts/OfferPage/offerPageStateReducer'
import { EmptyArray } from 'lib/array/arrayUtils'
import type { ReducerMiddleware } from 'lib/redux/reducerUtils'
import type { Dispatch } from 'react'
import { useEffect, useReducer } from 'react'

interface Options {
  syncAirportDefault?: boolean
}

function useOfferPageReducer(
  defaultState: Partial<OfferPageState>,
  middlewares: Array<ReducerMiddleware<OfferPageState, OfferPageDispatchAction>> = EmptyArray,
  { syncAirportDefault = false }: Options = {},
): [state: OfferPageState, dispatch: Dispatch<OfferPageDispatchAction>] {
  const [state, dispatch] = useReducer(offerPageStateReducer(middlewares, true), { ...INITIAL_OFFER_PAGE_STATE, ...defaultState })
  const { airport, airportSource } = defaultState

  useEffect(() => {
    if (syncAirportDefault) {
      dispatch({ type: OfferPageActions.syncDefaultAirport, airport, airportSource })
    }
  }, [airport, airportSource, syncAirportDefault])

  return [state, dispatch]
}

export default useOfferPageReducer
